import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { RamoService } from './shared/ramo.service';
import { ToastrService } from 'ngx-toastr';
import 'datatables.net';
import 'datatables.net-bs4';
import { Ramo } from './shared/ramo';
import * as $ from 'jquery';

@Component({
  selector: 'app-ramo',
  templateUrl: './ramo.component.html',
  styleUrls: ['./ramo.component.css']
})
export class RamoComponent implements OnInit {

  datatable: any;

  ListRamo: Ramo[] = [];

  constructor(private ramoService: RamoService,
    private toastr: ToastrService,
    private chRef: ChangeDetectorRef) { }

  getRamo() {
    this.ramoService.getRamo().then(r => {

      if ($.fn.dataTable.isDataTable('#datatable')) {
        this.datatable.destroy();
      }

      this.ramoService.listRamo.forEach((item) => {
        this.ListRamo.push({ idAdmRamo: item.idAdmRamo, codigo: item.codigo, nombre: item.nombre, especialidad: item.especialidad, aplicaPac: item.aplicaPac });
      });

      this.chRef.detectChanges();

      const table: any = $('table');
      this.datatable = table.DataTable({
        responsive: true
      })

    });
  }

  ngOnInit() {
    this.getRamo();
    //this.refreshList();
  }

  refreshList() {
    this.ramoService.getRamo();
  }

  updateRamo() {
    this.ramoService.updateRamo().then(r => { this.toastr.success("Ok!"); this.refreshList() });
  }

}
